import React, { useContext } from 'react';
import { useTheme } from 'ThemeContext';

import WidgetAdvertisement from './WidgetAdvertisement';
import WidgetBanner from './WidgetBanner';
import WidgetFacebookPagePanel from './WidgetFacebookPagePanel';
import WidgetHTML from './WidgetHTML';
import WidgetIframe from './WidgetIframe';
import WidgetIcon from './WidgetIcon';
import WidgetDisabledFacilities from './WidgetDisabledFacilities';
import WidgetImage from './WidgetImage';
import WidgetItem from './WidgetItem';
import WidgetList from './WidgetList';
import WidgetPartners from './WidgetPartners';
import WidgetLuckyNumber from './WidgetLuckyNumber';
import WidgetNews from './WidgetNews';
import WidgetNewsGrid from './WidgetNewsGrid';
import WidgetGallery from './WidgetGallery';
import WidgetSpacer from './WidgetSpacer';
import WidgetSpacerVertical from './WidgetSpacerVertical';
import WidgetBoxSpacer from './WidgetBoxSpacer';
import WidgetTitle from './WidgetTitle';
import WidgetContactForm from './WidgetContactForm';
import WidgetArticleDetails from '../ArticleDetails';
import WidgetCalendar from './WidgetCalendar';
import WidgetNameDay from './WidgetNameDay';
import WidgetWeather from './WidgetWeather';
import WidgetEvents from './WidgetEvents';
import WidgetGalleriesGrid from './WidgetGalleriesGrid';
import WidgetItemsGrid from './WidgetItemsGrid';
import WidgetLinksUnderBanner from './WidgetLinksUnderBanner';
import WidgetSchoolMenu from './WidgetSchoolMenu';
import WidgetLessonPlan from './WidgetLessonPlan';

import { AppSettingsContext } from 'AppSettingsContext';

import { Item, Wrapper } from './Widgets.style';
function switchIdToType(id) {
  let type;

  switch (id) {
    case 3: {
      type = 'icon';
      break;
    }
    case 4: {
      type = 'icon';
      break;
    }
    case 5: {
      type = 'html';
      break;
    }
    case 6: {
      type = 'item';
      break;
    }
    case 2: {
      type = 'news';
      break;
    }
    case 7: {
      type = 'gallery';
      break;
    }
    case 1: {
      type = 'advertisement';
      break;
    }
    case 8: {
      type = 'title';
      break;
    }
    case 9: {
      type = 'banner';
      break;
    }
    case 10: {
      type = 'lucky_number';
      break;
    }
    case 11: {
      type = 'fb_page_panel';
      break;
    }
    case 12:
    case 13: {
      type = 'list';
      break;
    }
    case 14: {
      type = 'disabled_facilities';
      break;
    }
    case 15: {
      type = 'contact_form';
      break;
    }
    case 16: {
      type = 'iframe';
      break;
    }
    case 17: {
      type = 'box_spacer';
      break;
    }
    case 18: {
      type = 'article';
      break;
    }
    case 19: {
      type = 'nameday';
      break;
    }
    case 25: {
      type = 'vertical';
      break;
    }
    case 21: {
      type = 'weather';
      break;
    }
    case 22: {
      type = 'partners';
      break;
    }
    case 23: {
      type = 'calendar';
      break;
    }
    case 24: {
      type = 'galleries_grid';
      break;
    }
    case 26: {
      type = 'events';
      break;
    }
    case 27: {
      type = 'linksUnderBanner';
      break;
    }
    case 28: {
      type = 'itemsGrid';
      break;
    }
    case 29: {
      type = 'schoolMenu';
      break;
    }
    case 30: {
      type = 'lessonPlan';
      break;
    }
    case 31: {
      type = 'image';
      break;
    }
    // case 20: {
    //   type = 'newsgrid';
    //   break;
    // }
    // case 21: {
    //   type = 'partners';
    //   break;
    // }
    // case 22: {
    //   type = 'calendar';
    //   break;
    // }
    // case 23: {
    //   type = 'events';
    //   break;
    // }
    // case 24: {
    //   type = 'nameday';
    //   break;
    // }
    // case 25: {
    //   type = 'weather';
    //   break;
    // }

    default:
      type = '';
  }
  return type;
}

function Widgets({ widgets = [], horizontal = undefined }) {
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);
  return (
    <Wrapper theme={theme.widgets.wrapper} horizontal={horizontal}>
      {widgets &&
        widgets.map((widget, key) => {
          widget.type =
            widget.type ||
            (widget.data && widget.data.type) ||
            switchIdToType(widget.widget_id);
          if (widget.type && widget.data) {
            switch (widget.type) {
              case 'title': {
                return (
                  <Item key={key}>
                    {widget.data.title || widget.data.text ? (
                      <WidgetTitle
                        title={widget.data.title || widget.data.text}
                        titleColor={widget.data.color}
                        titleBackground={widget.data.background}
                      />
                    ) : (
                      <WidgetSpacer />
                    )}
                  </Item>
                );
              }
              case 'box_spacer': {
                return (
                  <Item key={key}>
                    <WidgetBoxSpacer data={widget.data} />
                  </Item>
                );
              }
              case 'disabled_facilities': {
                return (
                  <Item key={key}>
                    <WidgetDisabledFacilities data={widget.data} />
                  </Item>
                );
              }
              case 'list': {
                return (
                  <Item key={key}>
                    <WidgetList
                      title={widget.data.title}
                      titleColor={widget.data.color}
                      titleBackground={widget.data.background}
                      data={widget.data.data}
                    />
                  </Item>
                );
              }
              case 'partners': {
                return (
                  <Item key={key}>
                    <WidgetPartners
                      autoplaySpeed={widget.data.autoplaySpeed}
                      data={widget.data.images}
                      title={widget.data.title}
                      titleColor={widget.data.color}
                      isActive={true}
                    />
                  </Item>
                );
              }
              case 'item': {
                return (
                  <Item key={key}>
                    <WidgetItem data={widget.data} />
                  </Item>
                );
              }
              case 'vertical': {
                return (
                  <Item key={key}>
                    <WidgetSpacerVertical data={widget.data} />
                  </Item>
                );
              }
              case 'image': {
                return (
                  <Item key={key}>
                    <WidgetImage data={widget.data} />
                  </Item>
                );
              }
              case 'news': {
                return (
                  <Item key={key}>
                    <WidgetNews
                      counterTitle={key % 2}
                      appSettings={appSettings}
                      title={widget.data.title}
                      subtitle={widget.data.subtitle}
                      isReverted={widget.data.mirrored}
                      titleColor={widget.data.color}
                      titleBackground={widget.data.background}
                      linkBackground={widget.data.show_all_background_color}
                      linkColor={widget.data.show_all_link_color}
                      readMoreLinkColor={widget.data.read_more_link_color}
                      firstReadMoreLinkColor={
                        widget.data.read_more_button_color_text
                      }
                      slug={widget.data.slug}
                      data={widget.data.data}
                      theme_id={appSettings.theme}
                    />
                  </Item>
                );
              }
              case 'newsgrid': {
                return (
                  <Item key={key}>
                    <WidgetNewsGrid
                      title={widget.data.title}
                      subtitle={widget.data.subtitle}
                      titleColor={widget.data.color}
                      titleBackground={widget.data.background}
                      linkBackground={widget.data.show_all_background_color}
                      linkColor={widget.data.show_all_link_color}
                      readMoreLinkColor={widget.data.read_more_link_color}
                      linkText={widget.data.linkText}
                      firstReadMoreLinkColor={
                        widget.data.read_more_button_color_text
                      }
                      slug={widget.data.slug}
                      data={widget.data.data}
                      isReverted={widget.data.isReverted}
                    />
                  </Item>
                );
              }
              case 'gallery': {
                return (
                  <Item key={key}>
                    <WidgetGallery
                      title={widget.data.title}
                      data={widget.data.data}
                    />
                  </Item>
                );
              }
              case 'html': {
                return (
                  <Item key={key}>
                    <WidgetHTML data={widget.data.text} />
                  </Item>
                );
              }
              case 'icon': {
                return (
                  <Item key={key}>
                    <WidgetIcon
                      data={widget.data}
                      theme_id={appSettings.theme}
                    />
                  </Item>
                );
              }
              case 'advertisement': {
                return (
                  <Item key={key}>
                    <WidgetAdvertisement data={widget.data} />
                  </Item>
                );
              }
              case 'banner': {
                return (
                  <Item key={key}>
                    <WidgetBanner
                      random={
                        widget.data.random
                          ? Math.floor(
                              Math.random() * widget.data.images.length
                            )
                          : undefined
                      }
                      autoplaySpeed={widget.data.autoplaySpeed}
                      data={widget.data.images}
                    />
                  </Item>
                );
              }
              case 'lucky_number': {
                return (
                  <Item key={key}>
                    <WidgetLuckyNumber data={widget.data} />
                  </Item>
                );
              }
              case 'iframe': {
                return (
                  <Item key={key}>
                    <WidgetIframe data={widget.data} />
                  </Item>
                );
              }
              case 'fb_page_panel': {
                return (
                  <Item key={key}>
                    <WidgetFacebookPagePanel data={widget.data} />
                  </Item>
                );
              }
              case 'contact_form': {
                return (
                  <Item key={key}>
                    <WidgetContactForm data={widget.data} />
                  </Item>
                );
              }
              case 'article': {
                return (
                  <Item key={key}>
                    <WidgetArticleDetails data={widget.data.content} />
                  </Item>
                );
              }
              case 'calendar': {
                return (
                  <Item key={key}>
                    <WidgetCalendar
                      data={widget.data.data}
                      todayDate={widget.data.todayDate}
                      slug={widget.data.slug}
                    />
                  </Item>
                );
              }
              case 'events': {
                return (
                  <Item key={key}>
                    <WidgetEvents
                      title={widget.data.title}
                      todayDate={widget.data.todayDate}
                      data={widget.data.data}
                      slug={widget.data.slug}
                    />
                  </Item>
                );
              }
              case 'nameday': {
                return (
                  <Item key={key}>
                    <WidgetNameDay date={widget.data.date} />
                  </Item>
                );
              }
              case 'weather': {
                return (
                  <Item key={key}>
                    <WidgetWeather
                      textColor={widget.data.textColor}
                      cityName={widget.data.cityName}
                      title={widget.data.title}
                    />
                  </Item>
                );
              }
              case 'galleries_grid': {
                return (
                  <Item key={key}>
                    <WidgetGalleriesGrid
                      title={widget.data.title}
                      titleColor={widget.data.title_color}
                      titleBackground={widget.data.title_background}
                      linkBackground={widget.data.read_more_background}
                      linkColor={widget.data.read_more_color}
                      linkText={widget.data.linkText}
                      slug={widget.data.slug}
                      data={widget.data.data}
                    />
                  </Item>
                );
              }
              case 'linksUnderBanner': {
                return (
                  <Item key={key}>
                    <WidgetLinksUnderBanner
                      positioned_up={widget.data.positioned_up}
                      data={widget.data.data}
                    />
                  </Item>
                );
              }
              case 'itemsGrid': {
                return (
                  <Item key={key}>
                    <WidgetItemsGrid
                      title={widget.data.title}
                      data={widget.data.data}
                    />
                  </Item>
                );
              }
              case 'schoolMenu': {
                return (
                  <Item key={key}>
                    <WidgetSchoolMenu
                      title={widget.data.title}
                      data={widget.data.children}
                    />
                  </Item>
                );
              }
              case 'lessonPlan': {
                return (
                  <Item key={key}>
                    <WidgetLessonPlan
                      title={widget.data.title}
                      data={widget.data.children}
                    />
                  </Item>
                );
              }
              default:
            }
          }
          return '';
        })}
    </Wrapper>
  );
}

export default Widgets;
